if (!customElements.get('c-drawer')) {
  class Drawer extends HTMLElement {
    constructor() {
      super();

      // default options
      this.default = {
        placement: this.dataset.placement || 'right',
        backdrop: this.dataset.backdrop === 'true' ? true : false,
        backdropClasses: this.dataset.backdropClasses || 'bg-white backdrop-blur-sm bg-opacity-50 fixed inset-0 z-40 cursor-pointer',
      };

      this.init();

      this.drawerTrigger?.addEventListener('click', () => {
        this.open();
      });

      // click event for close button
      this.drawerClose?.forEach((drawerClose) => {
        drawerClose.addEventListener('click', () => {
          this.close();
        });
      });
    }

    init() {
      let _this = this;

      _this.visible = false;

      // get drawer element
      _this.drawerTrigger = _this.querySelector('[data-drawer-target]');

      _this.drawerId = _this.dataset.componentId;
      _this.drawerElement = _this.querySelector('#' + _this.drawerId);
      if (!_this.drawerElement) return;

      _this.drawerClose = _this.querySelectorAll('[data-drawer-close]');

      const drawerTarget = _this.drawerTrigger?.dataset.drawerTarget;
      if (drawerTarget == 'Header-search-drawer') {
        _this.isHeaderSearchDrawer = true;
      } else {
        _this.isHeaderSearchDrawer = false;
      }
    }

    open() {
      let _this = this;
      if (_this.drawerTrigger?.dataset?.drawerTarget == 'Mobile-menu-drawer') {
        _this.lockPageScroll();
      }

      const openDrawer = document.querySelector('[data-drawer-open]');
      if (openDrawer) {
        openDrawer.querySelector('[data-drawer-close]')?.click();
        openDrawer.removeAttribute('data-drawer-open');
      }

      _this.drawerElement.classList.add('translate-none');
      _this.drawerElement.classList.remove(_this.getPlacementClasses(_this.default.placement).inactive);

      document.body.classList.add('overflow-hidden');
      if (_this.default.backdrop) {
        _this.createBackdrop();
      }

      if (_this.isHeaderSearchDrawer) {
        _this.drawerElement.querySelector('input[type="search"').focus();
      }

      const event = new Event('drawer-opened');
      _this.dispatchEvent(event);

      _this.visible = true;
      _this.setAttribute('data-drawer-open', true);
      const isMain = _this.closest('#main');
      if (isMain) {
        isMain.style.zIndex = 50;
        isMain.style.position = 'relative';
      }
    }

    close() {
      let _this = this;
      _this.unlockPageScroll();

      _this.drawerElement.classList.remove('translate-none');
      _this.drawerElement.classList.add(_this.getPlacementClasses(_this.default.placement).inactive);

      document.body.classList.remove('overflow-hidden');

      if (_this.default.backdrop) {
        _this.destroyBackdropEl();
      }
      _this.visible = false;
      _this.removeAttribute('data-drawer-open');

      const isMain = _this.closest('#main');
      if (isMain) {
        isMain.style.zIndex = '';
        isMain.style.position = '';
      }
    }

    createBackdrop() {
      let _this = this;

      if (!_this.visible) {
        const backdropEl = document.createElement('div');
        backdropEl.setAttribute('drawer-backdrop', _this.drawerId);
        backdropEl.classList.add(..._this.default.backdropClasses.split(' '));
        if (!_this.querySelector(`[drawer-backdrop]`)) {
          _this.append(backdropEl);
        }

        backdropEl.addEventListener('click', () => {
          _this.close();
        });
      }
    }

    destroyBackdropEl() {
      if (this.visible && this.drawerId) {
        this.querySelector(`[drawer-backdrop="${this.drawerId}"]`).remove();
      }
    }

    getPlacementClasses(placement) {
      switch (placement) {
        case 'left':
          return {
            base: 'top-0 left-0 h-screen',
            inactive: '-translate-x-full',
          };
        case 'top':
          return {
            base: 'top-0 left-0 right-0 w-full',
            inactive: '-translate-y-full',
          };
        case 'bottom':
          return {
            base: 'bottom-0 left-0 right-0 w-full',
            inactive: 'translate-y-full',
          };
        default:
          return {
            base: 'top-0 right-0 h-screen',
            inactive: 'translate-x-full',
          };
      }
    }

    lockPageScroll() {
      document.body.classList.add('overflow-hidden');
      document.body.classList.add('fixed');
    }

    unlockPageScroll() {
      document.body.classList.remove('overflow-hidden');
      document.body.classList.remove('fixed');
    }

  }
  customElements.define('c-drawer', Drawer);

  class HeaderDrawer extends Drawer {
    constructor() {
      super();

      this.menuDrawerCloseButtons = this.querySelectorAll('.menu-drawer__close-button');

      this.menuDrawerCloseButtons.forEach((menuDrawerCloseButton) => {
        menuDrawerCloseButton.addEventListener('click', () => this.closeMenuDrawer(menuDrawerCloseButton));
      });
    }

    closeMenuDrawer(button) {
      button.closest('details').removeAttribute('open');
    }
  }
  customElements.define('header-drawer', HeaderDrawer);
}

// give possibility to open drawer from any element
const buttons = document.querySelectorAll('[data-open-drawer]');
for (const button of buttons) {
  button.addEventListener('click', () => {
    const drawer = document.querySelector('[data-component-id=' + button.dataset.openDrawer + ']');
    if (drawer) drawer.open();
  });
}

